/* ============================================================================
 * Movatic WMS — Frontend | MES » WorkCentersPage | CesarFilho 932048016
 * ========================================================================== */

import React, { useEffect, useState } from "react";
import MES, { WorkCenter } from "@/api/mes";

export default function WorkCentersPage() {
    const [rows, setRows] = useState<WorkCenter[]>([]);
    const [q, setQ] = useState("");

    async function refresh() {
        try {
            const data = await MES.listWorkCenters();
            setRows(Array.isArray(data) ? data : []);
        } catch (e: any) {
            alert("Erro ao listar WC: " + e.message);
            setRows([]);
        }
    }

    useEffect(() => { refresh(); }, []);

    const filtered = (Array.isArray(rows) ? rows : []).filter(
        (r) =>
            !q ||
            r.code.toLowerCase().includes(q.toLowerCase()) ||
            r.name.toLowerCase().includes(q.toLowerCase())
    );

    return (
        <div className="p-4 space-y-4">
            <div className="flex items-center gap-2">
                <h1 className="text-xl font-semibold">MES — Centros de Trabalho</h1>
                <button className="px-3 py-1 rounded bg-gray-800" onClick={refresh}>Recarregar</button>
                <input
                    className="ml-auto px-2 py-1 rounded bg-gray-900 border border-gray-700"
                    placeholder="Pesquisar (código/nome)"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                />
            </div>

            <div className="overflow-auto rounded border border-gray-800">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-900">
                        <tr>
                            <th className="p-2 text-left">Código</th>
                            <th className="p-2 text-left">Nome</th>
                            <th className="p-2 text-left">Tipo</th>
                            <th className="p-2 text-left">Capacidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map((r) => (
                            <tr key={r.id} className="border-t border-gray-800">
                                <td className="p-2">{r.code}</td>
                                <td className="p-2">{r.name}</td>
                                <td className="p-2">{r.kind}</td>
                                <td className="p-2">{r.capacity}</td>
                            </tr>
                        ))}
                        {filtered.length === 0 && (
                            <tr><td className="p-6 text-center text-gray-400" colSpan={4}>Sem WC.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
